import { axiosPublic } from '../config';

export const verifyAccount = async (data) => {
  try {
    var res = await axiosPublic.post('/OT/AccountVerification', data)
    return res.data
  } catch (e) {    
    return res
  }
}